<template>
  <!--    <teleport to="body">-->
  <!--        <div class="create-event-save">-->
  <!--            <app-button type="button"-->
  <!--                        @click.native="saveEvent"-->
  <!--                        :shrink="false"-->
  <!--                        :loading="saving"-->
  <!--                        :disabled="saving"-->
  <!--                        class="btn btn-next">{{ $trans('event.create.save') }}</app-button>-->
  <!--        </div>-->
  <!--    </teleport>-->
  <div
    class="create-event-steps"
    :class="event.current_locale === 'en' ? 'en-class' : 'he-class'"
  >
    <div class="step-items" :class="[`step-${currentStep}`]">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item"
        @click="goToStep(index)"
        :class="{
          active: currentStep === Number(index),
          complete: currentStep > Number(index),
          inactive: index > currentStep,
        }"
      >
        <!-- {{ step.title  }} -->
        <div class="step-num">
          <span v-if="currentStep > Number(index)">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <path
                d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
                                        c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
                                        C514.5,101.703,514.499,85.494,504.502,75.496z"
              />
            </svg>
          </span>
          <span v-else>{{ index + 1 }}</span>
        </div>
        <div class="step-name">{{ step.title }}</div>
        <!-- <div class="step-name">{{ $t('my_page_title') }}</div>  -->
      </div>
    </div>

    <div class="event-step-component">
      <form @submit.prevent="submit" novalidate>
        <transition name="fade-left">
          <component
            @pushState="pushStepState"
            :current-step="currentStep"
            :form="form"
            :step="stepItem"
            :errors="errors"
            :is="stepItem.component"
          >
          </component>
        </transition>

        <div
          class="event-step-actions"
          v-if="
            currentStep < steps.length - 1 ||
            (currentStep >= steps.length - 1 && form.EventDetails.type)
          "
        >
          <app-button
            type="submit"
            :shrink="false"
            v-if="currentStep < steps.length - 1"
            :loading="loading"
            class="btn btn-next"
            >{{ $trans("event.create.next") }}
            <!-- branding details : {{ brandingDetails }} -->
            <!-- BrandingDetails : { "player_description" : "" } -->
          </app-button>

          <template v-if="currentStep >= steps.length - 1">
            <template v-if="onDetails">
              <app-button
                type="button"
                :disabled="loading"
                :loading="loading"
                :shrink="false"
                @click="saveAsDraft"
                class="btn btn-prev"
                >{{ $trans("event.create.save_draft") }}</app-button
              >

              <!-- here -->

              <app-button
                type="button"
                :loading="saving"
                :shrink="false"
                @click="publishEvent"
                :branding-details="BrandingDetails"
                class="btn btn-next"
                >{{ $trans("event.create.submit_event") }}</app-button
              >
            </template>

            <template v-else>
              <app-button
                type="button"
                :shrink="false"
                :loading="savingCoverImage"
                @click.native="saveCoverImage"
                class="btn btn-next"
                >{{ $trans("event.create.next") }}</app-button
              >
            </template>
          </template>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";

import queryString from "../../../plugins/query-string-object";

import EventDetails from "./EventDetails.vue";
import RegistrationDetails from "./RegistrationDetails.vue";
import BrandingDetails from "./BrandingDetails.vue";

export default {
  components: { EventDetails, RegistrationDetails, BrandingDetails },
  data() {
    return {
      steps: window.app.steps,
      event: window.app.event,
      form: window.app.form,
      errors: this.$api.errors(),
      eventId: window.app.event.id,
      draft: window.app.event.draft,
      currentStep: 0,
      loading: false,
      saving: false,
      onDetails: false,
      savingCoverImage: false,
      stepForm: {
        show_second_extra_description: false,
        second_extra_description: "", // Ensure this is initialized
      },
      // BrandingDetails: {
      //   player_name: "",
      //   player_description: "",
      //   player_email: "",
      //   player_email_2: "",
      //   player_email: "",
      //   player_business_phone: "",
      //   player_address: "",
      // },
    };
  },
  mounted() {
    console.log("stepsssss", this.steps);
    console.log("event", this.event);
    console.log("form", this.form);
    // console.log("stepsssss", this.steps);
    window.eventBus.on("onDetails", (onDetails) => {
      this.onDetails = onDetails;
    });

    window.addEventListener("hashchange", () => {
      this.hashStepChange();
    });

    nextTick(() => {
      if (this.event.current_step > 0) {
        this.currentStep = this.event.current_step;
      }

      this.hashStepChange();
    });
  },

  watch: {
    currentStep(val) {
      console.log("val", val);
    },
  },
  methods: {
    hashStepChange() {
      let hash = window.location.hash.substring(2);
      let parameters = hash.split("/");
      let query = hash.split("?");
      query = query.pop();
      hash = parameters.shift();

      if (query) {
        query = queryString.parse(query);

        if (query.step) {
          this.currentStep = parseInt(query.step);

          if (this.currentStep > this.steps.length - 1) {
            this.currentStep = 0;

            this.pushStepState({
              step: this.currentStep,
            });
          }
        }
      } else {
        this.pushStepState({
          step: this.currentStep,
        });
      }
    },
    pushStepState(params = {}) {
      let query = queryString.stringify(params);

      window.history.pushState(null, null, "#?" + query);

      window.eventBus.emit("stepChange");

      this.hashStepChange();
    },
    goToStep(index) {
      if (index > this.currentStep) {
        return;
      }

      this.currentStep = index;

      $(".split-view-panel.event-steps").scrollTop(0);

      this.pushStepState({
        step: index,
      });
    },
    saveEvent() {
      this.toast.info("test");
    },
    async saveAsDraft() {
      const saved = await this.validateAndSave(true);

      if (saved) {
        this.$swal({
          position: "top-center",
          icon: "success",
          title: this.$trans("event.create.you_saved_event"),
          text: this.$trans("event.create.draft_saved"),
          showConfirmButton: false,
          timer: 4000,
        });

        setTimeout(() => {
          if (this.eventId && !this.draft) {
            window.location.href = `${this.event.manage_events}?highlight=${this.eventId}`;
          } else {
            window.location.href = `${this.event.manage_events}?highlight=${this.eventId}&draft=1`;
          }
        }, 2500);
      }
    },

    async publishEvent() {
      console.log("saveform", this.form);

      if (this.saving) {
        return;
      }
      this.saving = true;

      const saved = await this.validateAndSave();

      if (!saved) {
        this.saving = false;
        return;
      }

      this.form.second_extra_description =
        this.stepForm.second_extra_description;

      let url = `event/finalize`;

      if (this.eventId) {
        url += `/${this.eventId}`;
      }

      if (this.draft) {
        url += `/1`;
      }
      // console.log("form0000000000000000", this.form);

      try {
        const response = await this.$api.post(url, JSON.stringify(this.form), {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("resssfinalizerespssssss", response);
        if (response._original.status === 200) {
          this.$swal({
            position: "top-center",
            icon: "success",
            title: this.$trans("event.create.you_saved_event"),
            text: this.$trans("event.create.published_event"),
            showConfirmButton: false,
            timer: 4000,
          });
          setTimeout(() => {
            window.location.href = `${this.event.manage_events}?highlight=${
              response.data()?.event?.id
            }`;
          }, 2500);
        } else {
          // console.log("errorfinalize", response);
          this.toast.error(response._data.message);
        }
      } catch (error) {
        console.error("Errorfinalizeeeeeeeeee:", error);
        this.toast.error(
          this.$trans("event.create.validation_error"),
          this.$trans("event.create.validation_error_title")
        );
      } finally {
        this.saving = false;
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    async saveCoverImage() {
      if (this.savingCoverImage) {
        return;
      }

      window.eventBus.emit("saveCroppedImage");

      setTimeout(async () => {
        this.savingCoverImage = true;

        this.errors.clear();

        const stepForm = { ...this.form[this.stepItem.component] };

        if (stepForm.cover_image_changed) {
          if (stepForm.cover_image) {
            stepForm.cover_image = this.dataURLtoFile(
              stepForm.cover_image,
              "cover_image"
            );
          } else if (stepForm.pixabay_image) {
            stepForm.pixabay_image = this.dataURLtoFile(
              stepForm.pixabay_image,
              "pixabay_image"
            );
          }
        } else {
          delete stepForm.pixabay_image;
          delete stepForm.cover_image;
        }

        let url = `event/save-cover-image`;

        if (this.eventId) {
          url += `/${this.eventId}`;
        }

        if (this.draft) {
          url += `/1`;
        }

        console.log("new formm", this.form);
        // console.log("new stepppp formm", this.stepForm);

        // if (this.stepForm.type === "contact_me") {
        //   this.stepForm.payment_required = 0;
        // }
        if (this.form.EventDetails.type == "contact_me") {
          this.form.EventDetails.payment_required = 0;
        }

        const response = await this.$api.postFile(url, null, stepForm);
        this.savingCoverImage = false;

        if (response.hasErrors()) {
          this.errors = response.errors();

          if (this.stepItem.errors_display) {
            this.stepItem.errors_display.forEach((errKey) => {
              if (response.errors().get(errKey)) {
                this.toast.error(
                  this.$trans("event.create.validation_error"),
                  this.$trans(response.errors().get(errKey))
                );
              }
            });
          } else {
            this.toast.error(
              this.$trans("event.create.validation_error"),
              this.$trans("event.create.validation_error_title")
            );
          }

          return false;
        }

        window.eventBus.emit("onDetails", true);
        $(".split-view-panel.event-steps").scrollTop(0);
      }, 100);

      return true;
    },
    async validateAndSave(draft = false) {
      if (this.loading /*|| this.currentStep >= (this.steps.length - 1)*/) {
        return;
      }

      this.loading = true;

      this.errors.clear();

      const stepForm = { ...this.form[this.stepItem.component] };

      //  todo todo
      // if (stepForm.lecturer_image) {
      //     stepForm.lecturer_image = this.dataURLtoFile(
      //         stepForm.lecturer_image,
      //         "lecturer_image"
      //     );
      // }

      if (this.stepItem.component === "EventDetails") {
        delete stepForm.pixabay_image;
        delete stepForm.cover_image;
      }
      stepForm.second_extra_description =
        this.stepForm.second_extra_description;

      let url = `event/validate-step/${this.stepItem.component}`;

      console.log("API URL:", url);

      if (this.eventId) {
        url += `/${this.eventId}`;
      }

      if (this.draft) {
        url += `/1`;
      }

      if (draft) {
        url += `?draft=1`;
      }

      const response = await this.$api.post(url, stepForm);
      this.loading = false;

      if (response.hasErrors()) {
        this.errors = response.errors();

        if (this.stepItem.errors_display) {
          this.stepItem.errors_display.forEach((errKey) => {
            if (response.errors().get(errKey)) {
              this.toast.error(
                this.$trans("event.create.validation_error"),
                this.$trans(response.errors().get(errKey))
              );
            }
          });
        } else {
          this.toast.error(
            this.$trans("event.create.validation_error"),
            this.$trans("event.create.validation_error_title")
          );
        }

        return false;
      }

      window.app.event.has_draft = response.data().has_draft;
      window.app.event.has_events = response.data().has_events;

      return true;
    },
    async submit() {
      window.eventBus.emit("beforeStepSave", this.currentStep);

      setTimeout(async () => {
        const saved = await this.validateAndSave();

        if (!saved) {
          return;
        }

        $(".split-view-panel.event-steps").scrollTop(0);
        this.currentStep += 1;

        this.pushStepState({
          step: this.currentStep,
        });
      }, 0);
    },
    goBack() {
      if (this.currentStep <= 0) {
        return;
      }

      this.currentStep -= 1;

      this.pushStepState({
        step: this.currentStep,
      });
    },
  },
  computed: {
    stepItem() {
      return this.steps[this.currentStep];
    },
  },
};
</script>

<style scoped lang="scss">
.en-class .step-num {
  margin-right: 7px;
}
</style>
